import axios from "axios";

const getParams = () => {
    const token = localStorage.getItem("token");
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    };
};
export const fetchDataFromApi = async (url) => {
    try {
        const { data } = await axios.get(process.env.REACT_APP_BASE_URL + url, getParams())
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
}


export const uploadImage = async (url, formData) => {

    const { res } = await axios.post(process.env.REACT_APP_BASE_URL + url, formData)
    return res;
}

export const postData = async (url, formData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(process.env.REACT_APP_BASE_URL + url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });




        if (response.ok) {
            const data = await response.json();
            //console.log(data)
            return data;
        } else {
            const errorData = await response.json();
            return errorData;
        }

    } catch (error) {
        console.error('Error:', error);
    }


}


export const editData = async (url, updatedData) => {
    const { res } = await axios.put(`${process.env.REACT_APP_BASE_URL}${url}`, updatedData, getParams())
    return res;
}

export const deleteData = async (url) => {
    const { res } = await axios.delete(`${process.env.REACT_APP_BASE_URL}${url}`, getParams())
    return res;
}


export const deleteImages = async (url, image) => {
    const { res } = await axios.delete(`${process.env.REACT_APP_BASE_URL}${url}`, image);
    return res;
}


// Resend OTP
export const resendOtp = async (url) => {
    try {
        const token = localStorage.getItem("token");

        const { data } = await axios.post(process.env.REACT_APP_BASE_URL + url, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            // withCredentials: true
        });

        return data;
    } catch (error) {
        console.error("Error in resendOtp:", error.response?.data || error.message);
        throw error;
    }
};